import { WebConferenceErrorCode } from "@api/enums/errors/WebConference";
import {Modal} from "@common/Modal";
import i18n from "@service/locale/i18";

export const showConnectionErrorModal = (useRefreshButton = true) => {
    const modal = new Modal({
        title: i18n.t('web-conferences.connectionErrorTitle') as string,
        contentText: i18n.t('web-conferences.networkIssue') as string,
        buttons: [
            {
                text: i18n.t('common.close') as string,
                class: '',
                returnValue: false
            },
            {
                text: i18n.t(useRefreshButton ? 'common.refresh' : 'web-conferences.useProxy') as string,
                class: 'is-green',
                returnValue: true
            },
        ]
    });
    return modal.showConfirm<boolean>(false)
        .then(modalResult => {
            if (modalResult && useRefreshButton) {
                window.location.reload();
            }
            return modalResult;
        });
}

export const showAccessErrorModal = async (code: WebConferenceErrorCode) => {

    let text = "";

    switch (code) {
        case WebConferenceErrorCode.scheduleNotFound:
            text = i18n.t("meetings.appointment.isNotAvaliable").toString()
            break;
        case WebConferenceErrorCode.wrongTime:
            text = i18n.t("meetings.appointment.isEnded").toString()
            break;

        case WebConferenceErrorCode.banned:
            text = i18n.t("meetings.appointment.banned").toString()
            break;

        default:
            break;
    }

    const modal = new Modal({
        title: "Error",
        contentText: text || "Unknow Error",
        buttons: [
            {
                text: 'Ok',
                class: 'is-green is-middle',
                returnValue: true
            }
        ]
    });

    return await modal.showConfirm();
}
